import {apiAdminRetailerGet, apiAdminRetailerGlobalConfigGet} from "../../../../../api/admin/retailers";

export const getUserData = async (props) => {
  const userData = await apiAdminRetailerGet(props);
  const global_methods = await apiAdminRetailerGlobalConfigGet();

  const methods = (userData.merchant || {}).methods || {};
  const enabledMethods = methods.allowed || [];
  const disabledMethods = methods.blocked || [];
  const countries_allowed = methods.countries_allowed || [];
  const countries_blocked = methods.countries_blocked || [];
  const countries_short = methods.short_flow || [];

  const isGlobal = !Object.keys(methods).length;

  const available_methods = (global_methods || []).filter((method) => !disabledMethods.includes(method)).concat(enabledMethods);

  return {...userData, global_methods, merchant_methods: {available_methods, countries_allowed, countries_blocked, countries_short, isGlobal}};
}
